import React from 'react';

const IGImageCard = ({ image, active, item, tagCount }) => {
  const displayImage =
    item?.media_type === 'video'
      ? item?.thumbnail_image || image
      : image;

  return (
    <div className="d-flex flex-column gap-1 justify-content-center align-items-center position-relative mx-auto">
      {item.media_type === 'video' && (
        <div
          style={{
            position: 'absolute',
            borderRadius: '2px',
            top: '10px',
            right: '13px'
          }}
        >
          <i
            className="fas fa-play"
            style={{ color: '#ffffff', fontSize: '1.25em' }}
          ></i>
        </div>
      )}
      {tagCount > 0 && (
        <div
          className="w-20px h-20px px-2 py-2 position-absolute bottom-0 end-0 rounded bg-dark d-flex justify-content-center align-items-center"
          style={{
            alignItems: 'center',
            zIndex: 10
          }}
        >
          <div
            style={{
              width: '16px',
              aspectRatio: 1,
              alignItems: 'center',
              zIndex: 10,
              cursor: 'pointer'
            }}
            className="d-flex justify-content-center align-item-center "
          >
            <span className="text-white" role="status" aria-hidden="true">
              {tagCount}
            </span>
          </div>
        </div>
      )}
      <img
        style={{ objectFit: 'cover' }}
        src={displayImage}
        alt={'placeholder'}
        className={`img-thumbnail h-100px w-100px ${
          active && 'border border-primary'
        }`}
      />
    </div>
  );
};

export default IGImageCard;
